import { createTheme } from "@mui/material";

// Dense by default: phones from 320 px wide; body2 (14 px) and caption
// (12 px) carry the lists.
export const theme = createTheme({
  palette: {
    primary: { main: "#1f5f8b", contrastText: "#ffffff" },
    background: { default: "#f4f6f8", paper: "#ffffff" },
  },
  components: {
    MuiButton: {
      styleOverrides: { root: { textTransform: "none", fontWeight: 600 } },
    },
    MuiListSubheader: {
      styleOverrides: { root: { backgroundColor: "#f4f6f8" } },
    },
  },
});
